import { useQuery } from '@tanstack/vue-query'

import { explorerApi } from '~/api/client'
import { aiSummaryKey } from '~/api/service/query-keys.const'
import { aiQuestionType, IAiSummaryRequestParam } from '~/types/ai-summary.type'

export const aiSummaryService = {
  useGetAiSummary: (param: ComputedRef<IAiSummaryRequestParam>, requestBody: Ref<Record<string, unknown> | undefined>) => {
    const getAiSummary = () => {
      return explorerApi.aiController.getAiAnswer({
        question: param.value.question ?? aiQuestionType.SUMMARY,
        dataType: param.value.dataType,
        requestBody: requestBody.value
      })
    }

    return useQuery([ ...aiSummaryKey, param, requestBody ], getAiSummary, {
      enabled: computed(() => !!(param.value.question && param.value.dataType && requestBody.value)),
      staleTime: 1000 * 60 * 5,
      cacheTime: 1000 * 60 * 5
    })
  }
}